import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Container,
    Menu,
    MenuItem,
    MenuItems,
    MenuSeparator,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { MenuButton } from '@headlessui/react';
import {
    EllipsisVerticalIcon,
    PencilIcon,
    PlusIcon,
    TrashIcon,
} from '@heroicons/react/24/outline';
import { Link, router, usePage } from '@inertiajs/react';

const IndexView = () => {
    const { auth, sectors } = usePage().props;
    const { updateFilters, isSorted } = useFilters(['sectors']);
    const confirm = useConfirmationStore(state => state.confirm);

    const confirmDelete = sector =>
        confirm({
            title: 'Sector verwijderen?',
            description:
                'Weet je zeker dat je deze sector wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
            confirmLabel: 'Verwijderen',
            onConfirm: close => {
                destroy(sector);
                close();
            },
        });

    const destroy = sector => {
        router.delete(`/sectors/${sector.id}`, {
            preserveScroll: true,
            preserveState: true,
        });
    };

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`Sectoren (${sectors?.meta?.total || 0})`}
                >
                    {auth?.permissions?.includes('create sectors') && (
                        <Button
                            variant='primary'
                            as={Link}
                            href='/sectors/create'
                        >
                            <PlusIcon className='size-5' />
                            Nieuwe sector
                        </Button>
                    )}
                </SegmentHeader>
                <SegmentContent>
                    <SearchBarFilter only={['sectors']} />

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell
                                    sorted={isSorted('name')}
                                    onClick={() =>
                                        updateFilters('sort', 'name')
                                    }
                                >
                                    Naam
                                </TableHeaderCell>
                                <TableHeaderCell
                                    className='w-px'
                                    textAlign='right'
                                />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {sectors?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={2} />
                            )}

                            {sectors?.data?.map(sector => (
                                <TableRow key={sector.id}>
                                    <TableCell>
                                        {auth?.permissions?.includes(
                                            'update sectors'
                                        ) ? (
                                            <Link
                                                href={`/sectors/${sector.id}/edit`}
                                            >
                                                {sector.name}
                                            </Link>
                                        ) : (
                                            sector.name
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className='w-px'
                                        singleLine
                                        textAlign='right'
                                    >
                                        {[
                                            'update sectors',
                                            'delete sectors',
                                        ]?.some(permission =>
                                            auth?.permissions?.includes(
                                                permission
                                            )
                                        ) && (
                                            <Menu>
                                                <MenuButton>
                                                    <EllipsisVerticalIcon className='size-5' />
                                                </MenuButton>
                                                <MenuItems anchor='bottom end'>
                                                    {auth?.permissions?.includes(
                                                        'update sectors'
                                                    ) && (
                                                        <>
                                                            <MenuItem
                                                                as={Link}
                                                                href={`/sectors/${sector.id}/edit`}
                                                                icon={
                                                                    PencilIcon
                                                                }
                                                            >
                                                                Wijzigen
                                                            </MenuItem>

                                                            <MenuSeparator />
                                                        </>
                                                    )}
                                                    {auth?.permissions?.includes(
                                                        'delete sectors'
                                                    ) && (
                                                        <MenuItem
                                                            className='text-red-600'
                                                            onClick={() =>
                                                                confirmDelete(
                                                                    sector
                                                                )
                                                            }
                                                            icon={TrashIcon}
                                                        >
                                                            Verwijderen
                                                        </MenuItem>
                                                    )}
                                                </MenuItems>
                                            </Menu>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>
                <SegmentFooter>
                    <CustomPagination meta={sectors?.meta} only={['sectors']} />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default IndexView;
